import React from 'react';
import Swal from 'sweetalert2';

import Modal from './Modal';

import './ChangeToHubMultipleModal.scss';
import { Error, InternalAddress, Order } from '../../types/orderTypes';
import { changeOrderToHub } from '../../pages/orders/OrdersUtil';
import { Link } from 'react-router-dom';
import { fetchOrders } from '../../fetch/orderFetch';

interface State {
  ordersProcessed: number;
  orders?: Order[];
  loadingOrders: boolean;
}

interface Props {
  orderIds: string[];
  hubAddress: InternalAddress;
  onCloseModal: () => void;
  onSelectModal: () => void;
}

export default class ChangeToHubMultipleModal extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ordersProcessed: 0,
      orders: null,
      loadingOrders: true,
    };

    this.escFunction = this.escFunction.bind(this);
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.onCloseModal();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    const { orderIds } = this.props;
    fetchOrders(orderIds).then(orders => {
      this.setState({
        orders: orders,
        loadingOrders: false,
      });
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  changeToHub = async () => {
    const { orders } = this.state;

    const requests = orders.map(async order => {
      const result = changeOrderToHub(order, this.props.hubAddress);
      this.setState({ ordersProcessed: this.state.ordersProcessed + 1 });
      return result;
    });
    const result = await Promise.all(requests);
    const errors: Error[] = result
      .filter(res => res !== true)
      .flat() as Error[];

    setTimeout(() => this.props.onSelectModal(), 800);

    if (errors.length === 0) {
      await Swal.fire(
        'Success!',
        `${orders.length} Orders have been updated.`,
        'success'
      );

      window.location.reload();
    } else {
      const errorMessages = errors
        .map(
          ({ message, propertyPath }) =>
            `<div style="text-align: left; font-size: 1.5rem; margin-bottom: 5px;">Field: ${propertyPath}<br />Message: ${message}</div>`
        )
        .join('');
      const html = `<div>Some orders could not be updated<br /><br />${errorMessages}</div>`;

      await Swal.fire({
        title: 'Failure!',
        icon: 'warning',
        html,
      });
      window.location.reload();
    }
  };

  render() {
    const { orderIds } = this.props;
    const { loadingOrders } = this.state;

    return (
      <Modal
        title="Confirm changing address to Hub"
        onClose={() => this.props.onCloseModal()}
        buttons={[
          {
            title: 'Change',
            type: 'success',
            onClick: () => {
              this.changeToHub();
            },
            loading: loadingOrders,
            disabled: false,
          },
        ]}
      >
        <div className="change-to-hub-modal">
          <h5>Change sender to hub?</h5>
          {orderIds.length > 1 && (
            // Only when you're doing multiple Orders
            <>
              <div>
                {orderIds.map(orderId => (
                  <span key={orderId} className="change-to-hub-modal__orderid">
                    <Link to={`/orders/${orderId}`} target="_blank">
                      {orderId}
                    </Link>
                  </span>
                ))}
              </div>
              <div className="change-to-hub-modal__progress">
                <progress
                  max={orderIds.length}
                  value={this.state.ordersProcessed}
                />
              </div>
            </>
          )}
          <div />
        </div>
      </Modal>
    );
  }
}
